<template>
  <div class="container" :class="loading ? 'finance-wrap' : ''">
    <gkLoading color="orange" v-if="loading" />

    <template v-else>
      <stop-show v-if="!showVIPSections"/>
      <div v-else>
        <div v-if="stopTip && financeData && !Object.keys(financeData).length">
          <stop-show :custom="stopTip"/>
        </div>

        <div v-else class="content-wrap">
          <!-- PC端 -->
          <div class="menu-wrap" v-if="!isMobile">
            <div id="financeMenu" class="menu" v-if="nowBranch && nowBranch.name">
              <dl class="menu-item">
                <!-- 点击展开 -->
                <gkDropdown
                  class="dropdown now-branch"
                  :visible="showBranchDropDownVisible"
                >
                  <div @click.stop="toggleBranchDropDown" class="menu-item-title">
                    {{ `${nowBranch.name}财务报告` }}
                    <i class="iconfont group-expand-icon" v-if="branchList.length > 1">&#xe604;</i>
                  </div>

                  <div slot="popup" v-if="branchList.length > 1">
                    <div
                      class="dropdown-options"
                      v-clickoutside="toggleBranchDropDown"
                    >
                      <div
                        class="all-branch-list"
                        :class="{
                          'all-branch-list-select': nowBranch.id === item.id
                        }"
                        @click="toggle(item)"
                        v-for="item in branchList"
                        :key="item.id"
                      >
                        <i :class="{ 'all-branch-name-icon': nowBranch.id === item.id }"></i>
                        <span
                          class="all-branch-name"
                          :class="{ 'all-branch-name-select': nowBranch.id === item.id }"
                        >
                          {{ `${item.name}财务报告` }}
                        </span>
                      </div>
                    </div>
                  </div>
                </gkDropdown>

                <div class="menu-item-options">
                  <dd
                    class="menu-item-option"
                    :class="{ 'active': item.id === nowYearId }"
                    v-for="item in yearList"
                    :key="item.id"
                    @click="toggle({ id: nowBranch.id }, item)"
                  >
                    {{ item.name }}
                  </dd>
                </div>
              </dl>
            </div>
          </div>

          <!-- 移动端 -->
          <div v-else-if="nowBranch && nowBranch.name" class="menu-m" :style="{ zIndex: isShowMenu ? 1003 : 100 }">
            <div class="menu-header">

              {{ `${nowBranch.name}` }}
              <template v-if="nowYear && nowYear.name"> {{ `- ${nowYear.name}` }}</template>

              <div class="menu-box" @click="showMenu">
                <span class="menu-icon"></span>
              </div>

            </div>
            <div v-if="isShowMenu" class="menu-content" @touchmove.stop.prevent v-fixed>
              <div class="menu-title">目录</div>
              <div class="menu-close" @click.stop="hiddenMenu"></div>
              <dl
                class="menu-wrap"
                v-for="item in branchList"
                :key="item.id"
              >
                <dt class="menu-wrap-title">{{ `TGO 鲲鹏会${item.name}财务报告` }}</dt>
                <template
                  v-if="getFinanceBranchYearList({ branch_id: item.id }).length"
                >
                  <dd
                    class="menu-wrap-option"
                    v-for="each in getFinanceBranchYearList({ branch_id: item.id })"
                    :key="each.id"
                    @click.stop="toggle({ id: item.id }, each)"
                  >
                    {{ each.name }}
                  </dd>
                </template>
                <template v-else>
                  <stop-show class="stop-show-small" custom="您所在的该分会暂没有相关的财务数据展示" />
                </template>
              </dl>
            </div>
          </div>

          <div class="content">
            <div v-if="stopTip">
              <stop-show :custom="stopTip" />
            </div>
            <component :is="financeData.com" v-else-if="financeData" />
          </div>
        </div>
      </div>
    </template>
  </div>

</template>

<script>
import StopShow from '@/components/stopShow'

import gkLoading from 'gkui/loading'
import gkDropdown from 'gkui/dropdown/Dropdown.vue'

import service from '@/service'
import { mapGetters, mapState } from 'vuex'

import {
  getFinanceData,
  getFinanceBranchList,
  getFinanceBranchYearList
} from './content/static.service'

let allBranchArr = []
let tgoUserInfo = {}

export default {
  data () {
    return {
      loading: false,

      // 账户下的隶属分会列表
      branchList: [],
      // 选中分会下的年份列表
      yearList: [],
      // 当前财务数据
      financeData: null,
      nowBranch: {},
      nowYear: {},

      stopTip: '',

      isShowMenu: false,
      showBranchDropDownVisible: false
    }
  },
  components: {
    gkDropdown,
    gkLoading,
    StopShow
  },
  computed: {
    ...mapState({
      isMobile: 'isMobile'
    }),

    ...mapGetters([
      'showVIPSections'
    ]),

    // 选中的分会 Id
    nowBranchId () {
      return Number(this.$route.query.branch) || null
    },

    // 选中的年份 Id
    nowYearId () {
      return Number(this.$route.query.year) || null
    }
  },

  created () {
    const userPromise = service.getUserInfo() // 获取用户信息
    const branchPromise = service.getBranchesAll() // 获取分会信息

    this.loading = true
    Promise.all([userPromise, branchPromise]).then(res => {
      tgoUserInfo = res[0]
      allBranchArr = res[1]

      this.getData()
    }).catch(() => {
      this.$nextTick(() => {
        this.loading = false
      })
    })
  },

  mounted () {},

  watch: {
    $route (to, from) {
      this.stopTip = ''
      this.getData()
    }
  },

  methods: {
    getFinanceBranchYearList,
    getData () {
      let branchIdArr = !Array.isArray(tgoUserInfo.branch_id) ? [tgoUserInfo.branch_id] : tgoUserInfo.branch_id

      for (const item of branchIdArr) {
        const yearList = getFinanceBranchYearList({ branch_id: item })

        if (yearList.length) {
          this.yearList = yearList
          break
        }
      }

      // 1. 当前会员没分配任何分会
      if (branchIdArr.length === 1 && !branchIdArr[0]) {
        this.stopTip = '您还未分配分会，当前页面不可查看'

      // 2. 账户隶属的第一个分会下，没有任何年份的财务数据
      } else if (!this.yearList.length) {
        this.stopTip = '您所在的该分会暂没有相关的财务数据展示'

      // 3. query 中不存在当前的分支 ID => 导到账户下隶属的第一个分会的第一个年份
      } else if (!this.nowBranchId) {
        this.$router.replace({
          query: {
            branch: branchIdArr[0],
            year: this.yearList[0].id
          }
        })

      // 4. query 中只存在分支 ID
      } else if (this.nowBranchId) {
        const theId = branchIdArr.filter(item => item === this.nowBranchId)

        // 4.1 不是账户隶属分会的
        if (!theId.length) {
          const branchName = getFinanceBranchList({
            allBranchArr,
            branchIdArr: [this.nowBranchId]
          })[0].name

          this.stopTip = `该页面仅限 TGO 鲲鹏会${branchName}成员可见`
        // 4.2 不存在年份ID => 导到当前分会的第一个年份
        } else if (!this.nowYearId) {
          this.yearList = getFinanceBranchYearList({ branch_id: this.nowBranchId })

          this.branchList = getFinanceBranchList({
            allBranchArr,
            branchIdArr
          })

          this.nowBranch = this.branchList.filter(item => item.id === this.nowBranchId)[0]

          if (!this.yearList.length) {
            this.stopTip = '您所在的该分会暂没有相关的财务数据展示'
          } else {
            this.$router.replace({
              query: {
                branch: this.nowBranchId,
                year: this.yearList[0].id
              }
            })
          }

        // 4.3 存在当前的年份ID => 获取对应数据
        } else {
          this.yearList = getFinanceBranchYearList({ branch_id: this.nowBranchId })

          if (!this.yearList.length) {
            this.stopTip = '您所在的该分会暂没有相关的财务数据展示'
          } else if (!this.yearList.filter(item => item.id === this.nowYearId).length) {
            this.stopTip = '当前分会没有该年份的财务数据，请选择已有的年份财务数据'
          }

          this.branchList = getFinanceBranchList({
            allBranchArr,
            branchIdArr
          })

          this.nowBranch = this.branchList.filter(item => item.id === this.nowBranchId)[0]
          this.nowYear = this.yearList.filter(item => item.id === this.nowYearId)[0]

          this.financeData = getFinanceData({
            branch_id: this.nowBranchId,
            year_id: this.nowYearId
          })
        }
      }

      this.$nextTick(() => {
        this.loading = false
      })
    },
    toggle (branchItem, yearItem) {
      let query = {}

      if (!yearItem) {
        query = Object.assign(
          {},
          this.$route.query,
          {
            branch: branchItem.id
          }
        )
        delete query.year
      } else {
        query = Object.assign(
          {},
          this.$route.query,
          {
            branch: branchItem.id,
            year: yearItem.id
          }
        )
      }

      this.$router.replace({ query }, () => {})

      this.hiddenMenu()
      this.showBranchDropDownVisible = false
    },
    showMenu () {
      this.isShowMenu = true
    },
    hiddenMenu () {
      this.isShowMenu = false
    },
    toggleBranchDropDown () {
      this.showBranchDropDownVisible = !this.showBranchDropDownVisible
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/bulma/app.sass';

.finance-wrap {
  display: flex; align-items: center; justify-content: center;
  min-height: 80vh;
}

.content-wrap {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  @include mobile {
    display: block;
  }
}

a {
  display: block;
  width: 100%;
  height: 100%;
  color: inherit;
}

.menu-wrap {
  padding-top: 64px;
  @include mobile {
    padding: 0;
  }
}
.menu {
  // position: absolute;
  position: sticky; top: 140px;
  width: 252px;
  border-radius: 3px;
  padding: 30px 0;
  background: rgba(248, 248, 248, 0.5);
  @include mobile {
    position: absolute;
    // padding-top: 30px;
  }

  .menu-item {
    margin-bottom: 10px;

    .menu-item-title {
      position: relative;
      padding-bottom: 10px;
      font-size: 18px;
      font-weight: 700;
      color: #4A4A4A;
      cursor: pointer;
      user-select: none;
      @include limit-line-numbers(1);

      &::before {
        content: "";
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 1px;
        background: #EAEEEF;
      }

      & .iconfont {
        font-size: 14px;
      }
    }

    .menu-item-options {
      margin-top: 15px;
    }

    .menu-item-option {
      position: relative;
      color: #888888;
      font-size: 16px;
      font-weight: 400;
      padding: 12px 0 12px 20px;
      cursor: pointer;
      &.active {
        color: $primary3;
        background:rgba(215, 179, 117, 0.1);
        &::after {
          content: "";
          position: absolute;
          top: 50%;
          right: 16px;
          width: 10px;
          height: 6px;
          transform: translateY(-50%) rotate(90deg);
          background: url('./assets/arrow.png') no-repeat center / cover;
        }
      }
    }
  }
}

.dropdown {
  width: 100%;
  margin-left: 20px;
  & [gk-dropdown-popup] {
    top: 0;
  }
}

.dropdown-options {
  width: 176px; height: 212px;
  background: #FFFFFF;
  border: 1px solid #F1F1F1; border-radius: 5px;
  font-size: 14px;
  box-shadow: 0 -2px 15px rgba(228, 229, 231, 0.6);
}

.dropdown-option {
  display: flex;
  align-items: center;
  padding: 15px 10px 20px;
  font-size: 14px; font-weight: 400;
  line-height: 1;
}

.all-branch-list {
  display: flex;
  align-items: center;
  padding: 10px 0;
  word-wrap: break-word;
  word-break: break-all;
  cursor: pointer;
}

.all-branch-list-select {
  background: url('https://static001.geekbang.org/resource/image/e6/fe/e67a916c3469555df06e4854a2deebfe.png') center / cover no-repeat;
}

.all-branch-name-icon {
  position: absolute;
  display: inline-block;
  width: 3px; height: 16px;
  background: #D7B375;
}

.all-branch-name {
  width: 150px;
  padding-left: 13px;
  @include limit-line-numbers(1);
}

.all-branch-name-select {
  color: #D1A75F;
}

.menu-m {
  position: sticky;
  left: 0;
  top: 0;
  width: 100vw;
  height: 40px;
  margin-left: -4vw;
  line-height: 40px;
  text-align: center;
  background: #fff;
  box-shadow:0px 6px 12px 1px rgba(0, 0, 0, 0.1);
  z-index: 100;

  .menu-header {
    font-weight: 500;
    .menu-box {
      position: absolute;
      top: 0;
      right: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 40px;
      height: 40px;
      background: #fff;
      // &::before {
      //     content: "";
      //     position: absolute;
      //     left: 0;
      //     top: 50%;
      //     transform: translateY(-50%);
      //     width: 2px;
      //     height: 15px;
      //     background:rgba(136, 136, 136, 0.2);
      // }

      .menu-icon {
        position: relative;
        display: block;
        width: 18px;
        height: 15px;
        border-top: 2px solid #888;
        border-bottom: 2px solid #888;
        &::before {
          content: "";
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 18px;
          height: 2px;
          background: #888;
        }
      }

    }

  }

  .menu-content {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    padding: 0 4vw;
    text-align: left;
    background: #fff;

    .menu-title {
      display: inline-block;
      margin-top: 6vw;
      font-size: 18px;
      font-weight: 600;
      border-bottom: 3px solid $primary3;
    }

    .menu-close {
      position: absolute;
      top: 9vw;
      right: 6vw;
      width: 20px;
      height: 20px;
      &::before, &::after {
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        width: 20px;
        height: 2px;
        background: #888;
      }
      &::before {
        transform: rotate(45deg);
      }
      &::after {
        transform: rotate(-45deg);
      }
    }

    .menu-wrap {
      .menu-wrap-title {
        font-size: 16px;
        margin-top: -1px;
        border-top: 2px solid #EBEBEB;
      }
      .menu-wrap-option {
        font-size: 14px;
        margin-left: 18vw;
        border-bottom: 1px solid #EBEBEB;
        &:last-of-type {
          border: none;
        }
      }
    }
  }

  .stop-show-small {
    height: 200px;
    ::v-deep {
      .lock-img {
        width: 70px;
        margin-bottom: 15px;
      }
      .text1 {
        font-size: 14px;
      }
    }
  }
}

.content {
  flex: 1;
  // margin-left: 300px;
  min-height: 500px;
  @include mobile {
    margin-left: auto;
  }
}
</style>
